import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from '../../../../../../components/content/text';
import Button from '../../../../../../components/inputs/button';
import { Kind } from '../../../../../../components/inputs/button/constants/kind';
import COLORS from '../../../../../../constants/colors';
import FONTS from '../../../../../../constants/fonts';
import { tKeys } from '../../../../../../translations/keys';
import useLogic from './logic.web';
import { HStack, StackDivider, VStack, } from '@chakra-ui/react';
import LoadingWrapper from '../../../../../../components/utility/loading-wrapper/index.web';
import EditAgendaItem from '../../../edit-agenda-item/index.web';
import VoteResults from '../../../../../vote-results/index.web';
import { useDrop } from 'react-dnd';
import { AgendaItemRow } from '../agenda-item-row/index.web';
import { AgendaItemInput } from '../agenda-item-input/index.web';
const EventDetailsAgenda = ({ event, isCurrentUserInvited, isCurrentUserPresent, refetchEventTasks, isAdmin, }) => {
    // Attributes
    const { t } = useTranslation();
    const { agendaItems, onEditAgendaItem, onSelectAgendaItem, onAddPress, isAgendaItemsLoading, isVoteEnabled, onVotePress, isOpenEditAgendaItem, onCloseEditAgendaItem, agendaItemEntity, refetchAgendaItems, isOpenVoteResult, onCloseVoteResult, voteResultParams, handleDropAgendaItem, handleAgendaItemsRefetch, redirectToBoardPack, handleNewAgendaItem, isCreateLoading, defaultDocumentType, selectedCompanyId, } = useLogic(event);
    const [{ isOver }, drop] = useDrop({
        accept: 'agendaItem',
        collect: monitor => ({
            isOver: !!monitor.isOver({ shallow: true }),
        }),
        drop: (item, monitor) => {
            if (!monitor.isOver({ shallow: true }))
                return;
            void handleDropAgendaItem(item.agendaItemId, null, 0, true);
        },
    });
    console.log('agendaItems', agendaItems);
    console.log('agendaItems.length', agendaItems.length);
    // Render
    return (<LoadingWrapper isLoading={isAgendaItemsLoading}>
      <VStack alignItems={'flex-start'} width={'full'} spacing={'0.75rem'} pb={'2rem'} overflow={'auto'}>
        <VStack width={'100%'} alignItems={'flex-start'} spacing={0}>
          <HStack justify="space-between" px={'1rem'} py={'1.25rem'} width={'full'}>
            <Text font={FONTS.T1.T16Px.SemiBold600.value}>
              {t(tKeys.common.agenda)}
            </Text>
            <Button onPress={redirectToBoardPack} kind={Kind.OUTLINE}>
              {t(tKeys.agenda_items.view_board_pack)}
            </Button>
          </HStack>
          <VStack width={'full'} px={'1rem'} py={'1rem'} divider={isOver && (<StackDivider borderColor={COLORS.Govrn.Blue.T500.value}/>)}>
            <VStack width={'100%'} spacing={0}>
              {agendaItems.map((agendaItem, index) => (<AgendaItemRow key={agendaItem.id} item={agendaItem} index={index} agendaItems={agendaItems} onEditPress={onEditAgendaItem} isAdmin={isAdmin} refetchAgendaItems={refetchAgendaItems} isDraggable={isAdmin} handleDropAgendaItem={handleDropAgendaItem} isVoteEnabled={isVoteEnabled} onVote={onVotePress} isCurrentUserInvited={isCurrentUserInvited} isCurrentUserPresent={isCurrentUserPresent} defaultDocumentType={defaultDocumentType} selectedCompanyId={selectedCompanyId} eventId={event?.id}/>))}
              {isAdmin && (<AgendaItemInput index={agendaItems.length + 1} onChange={handleNewAgendaItem} agendaItemParentId={undefined} eventId={event?.id ?? ''} isLoading={isCreateLoading}/>)}
            </VStack>
          </VStack>
        </VStack>
        {/* Modals */}
        <EditAgendaItem isOpen={isOpenEditAgendaItem} onClose={onCloseEditAgendaItem} agendaItemEntity={agendaItemEntity} refetchAgendaItems={() => {
            void refetchAgendaItems();
            refetchEventTasks();
        }} isAdmin={isAdmin} event={event}/>
        <VoteResults isOpen={isOpenVoteResult} onClose={onCloseVoteResult} voteResultParams={voteResultParams}/>
      </VStack>
    </LoadingWrapper>);
};
export default EventDetailsAgenda;
